import axios from 'axios';
import { API, ApiKey } from '../config';
const headerAPI = { ApiKey: `${ApiKey}`};

export const getMenu = (id) => {
  return axios.get(`${API}/api/menus/week/${id}`, { headers: headerAPI });
};
